import { Col } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const VideoContainer = styled(Col)`
  height: 231.55px;
`;
